import AppSwitch from "@/components/AppSwitch";
import AppSelect from "@/components/AppSelect";
import AppSlider from "@/components/AppSlider";
import DemandForecastingSettingsGrid from "@/components/DemandForecastingSettingsGrid";
import DemandForecastingSettingsSeasonal from "@/components/DemandForecastingSettingsSeasonal";
export default {
  name: "DemandForecastingSettingsForecasting",
  components: {
    AppSwitch,
    AppSelect,
    AppSlider,
    DemandForecastingSettingsGrid,
    DemandForecastingSettingsSeasonal
  },
  props: {
    settings: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      data: {
        //current: JSON.parse(JSON.stringify(this.settings)),
        x: {
          title: "Period",
          values: ["7D", "14D", "30D", "90D"]
        },
        y: {
          title: "% of weight",
          values: ["200%", "175%", "150%", "125%", "100%", "75%", "50%", "25%", "0%"]
        }
      },
      velocityHeight: 0,
      resizeBar: null,
      resizeY: null,
      deltaY: 0,
      boost_types: [{
        value: "manual",
        text: "Manual"
      }, {
        value: "seasonal",
        text: "Seasonal"
      }, {
        value: "trend",
        text: "Trend"
      }],
      percents: []
    };
  },
  computed: {
    calculateHeight() {
      return (percent, bar) => {
        if (this.velocityHeight > 0) {
          let height = this.velocityHeight * percent / 200;
          if (this.resizeBar == bar) {
            height += this.deltaY;
          }
          if (height <= 0) {
            return 0;
          }
          if (height >= this.velocityHeight) {
            return this.velocityHeight;
          }
          return height;
        }
        return 0;
      };
    },
    currentSettings() {
      return JSON.parse(JSON.stringify(this.settings));
    }
  },
  created() {
    this.generatePercents();
  },
  mounted() {
    this.$nextTick(() => {
      this.velocityHeight = this.$refs.velocity.clientHeight;
    });
  },
  methods: {
    calculatePercent(bar) {
      if (bar) {
        const currentHeight = this.calculateHeight(this.currentSettings.forecasting_velocity[bar], bar);
        return currentHeight * 200 / this.velocityHeight;
      }
      return null;
    },
    onResizeStart(event, bar) {
      this.resizeBar = bar;
      this.resizeY = event.clientY;
    },
    onResize(event) {
      if (this.resizeBar) {
        this.deltaY = this.resizeY - event.clientY;
      }
    },
    onResizeStop() {
      const percent = this.calculatePercent(this.resizeBar);
      if (percent != null) {
        let current_settings = this.currentSettings;
        current_settings.forecasting_velocity[this.resizeBar] = this.calculatePercent(this.resizeBar);
        this.$emit("update", JSON.parse(JSON.stringify(current_settings)));
      }
      this.resizeBar = null;
      this.resizeY = null;
      this.deltaY = 0;

      //this.onUpdate()
    },
    onUpdate() {
      this.$emit("update", JSON.parse(JSON.stringify(this.currentSettings)));
    },
    onUpdateManualBoostValue($event) {
      let current_settings = this.currentSettings;
      current_settings["manual_boost_value"]["value"] = $event;
      this.$emit("update", JSON.parse(JSON.stringify(current_settings)));
    },
    onUpdateSeasonalBoostValue($event) {
      let current_settings = this.currentSettings;
      current_settings["seasonal_boost_value"] = $event;
      this.$emit("update", JSON.parse(JSON.stringify(current_settings)));
    },
    generatePercents() {
      let percents = [];
      const segments = [{
        from: -75,
        to: -50,
        steps: 4
      }, {
        from: -50,
        to: -25,
        steps: 4
      }, {
        from: -25,
        to: -10,
        steps: 3
      }, {
        from: -10,
        to: 0,
        steps: 2
      }, {
        from: 0,
        to: 10,
        steps: 2
      }, {
        from: 10,
        to: 25,
        steps: 3
      }, {
        from: 25,
        to: 50,
        steps: 4
      }, {
        from: 50,
        to: 75,
        steps: 4
      }, {
        from: 75,
        to: 100,
        steps: 4
      }, {
        from: 100,
        to: 150,
        steps: 5
      }, {
        from: 150,
        to: 200,
        steps: 5
      }, {
        from: 200,
        to: 300,
        steps: 5
      }, {
        from: 300,
        to: 400,
        steps: 5
      }];
      const getColors = value => {
        if (value === 0) return ["#595959", "#595959"];
        return value < 0 ? ["#FECDCD", "#DB333B"] : ["#CDE4BC", "#22863D"];
      };
      let labeledValues = new Set();
      segments.forEach(segment => {
        labeledValues.add(segment.from);
        labeledValues.add(segment.to);
      });
      const addValue = value => {
        const item = {
          value,
          tooltip: `${value}%`,
          label: labeledValues.has(value) ? `${value}%` : '',
          colors: getColors(value)
        };
        if (value === 0) item.start = true;
        percents.push(item);
      };
      for (const {
        from,
        to,
        steps
      } of segments) {
        const step = (to - from) / steps;
        for (let i = 0; i <= steps; i++) {
          const value = parseFloat((from + step * i).toFixed(2));
          if (!percents.some(p => p.value === value)) {
            addValue(value);
          }
        }
      }
      percents.sort((a, b) => a.value - b.value);
      this.percents = percents;
    }
  }
};